import { render, staticRenderFns } from "./weka-technical-error.vue?vue&type=template&id=6d3d8df0&lang=pug"
import script from "./weka-technical-error.vue?vue&type=script&lang=js"
export * from "./weka-technical-error.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports